import React, {memo, useState} from "react";
import cx from 'clsx';

import {IVariation} from "./variation";
import {SvgIcon} from '@montana/shared/svg-icon';
import {getDimensionTranslationValue} from '@montana/helpers/product.helper';
import {useTranslations} from '@montana/containers/translations';

interface IVariationDesktopButtonProps extends Omit<IVariation, "clickHandler"> {
    isActive: boolean;
    clickHandler(dimensionName: string): void;
}

export const VariationDesktopButton = memo<IVariationDesktopButtonProps>((props) => {
    const [hoverActive, setHoverActive] = useState(false);
    const translate = useTranslations();
    const onHover = (): void => {
        setHoverActive(true);
    };

    const onBlur = (): void => {
        setHoverActive(false);
    };

    return (
        <div className={cx('variation-button__wrap', { 'variation-button__wrap--spacing': props.spacing })}>
            <button
                onClick={() => props.clickHandler(props.dimensionName)}
                className={cx('variation-button', { 'variation-button--active': props.isActive, 'variation-button--hover': hoverActive})}
                type="button"
                onFocus={onHover}
                onBlur={onBlur}
                onMouseEnter={onHover}
                onMouseLeave={onBlur}
            >
                {props.isActive ? <SvgIcon className="variations-wrapper__icon" iconName="close" /> : props.buttonIcon}
                <p className="variation-button__label">
                    {`${props.buttonText}${!!props.selectedValue ? `: ${getDimensionTranslationValue(translate, props.selectedValue)}` : ""}`}
                </p>
            </button>
        </div>
    );
});
